<template>
  <div>
    <header-component position-relation></header-component>
    <div class="news-container body-max-container">
      <div class="news-body">
        <ul>
          <li>
            <div class="home-content-info">
              <div class="home-content-info-body">
                <div class="title">最新消息</div>
                <div class="space-box">
                  <img src="../assets/img/news-cat.svg" class="cat-img" alt="" />
                </div>
                <div class="news-list">
                  <div
                    v-for="(news) in getNewList"
                    :key="`NewItem_${news.newsId}`"
                    class="news-item"
                    :class="{ active: news.isOpened }"
                  >
                    <div
                      class="news-item-title"
                      @click="news.isOpened = !news.isOpened"
                    >
                      <span>{{ news.title }}</span>
                    </div>
                    <div class="news-item-content">
                      <span>{{ news.newsContent }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent";
import FooterComponent from "../components/FooterComponent";
import { NewsModel } from "@/models/news-model";
import { fetchNewsList } from "@/apis/news";
import IndexMixin from "@/mixins/index-mixin";
import { ResponseModel } from "@/models/response-model";

export default {
  name: "News",
  mixins: [IndexMixin],
  components: { FooterComponent, HeaderComponent },
  data() {
    return {
      newsModelList: [],
    };
  },
  computed: {
    /**
    * @return {[NewsModel]}
    */
    getNewList() {
      return this.newsModelList
    }
  },
  created() {
    window.scroll(0, 0)
  },
  mounted() {
    this.openLoading()
    fetchNewsList().then(res => {
      this.closeLoading()
      const response = new ResponseModel(res)
      if (response.isSuccess) {
        const { newsList } = response.result
        this.newsModelList = []
        for (const i in newsList) {
          this.newsModelList.push(new NewsModel(newsList[i]))
        }
      }
    }).catch(e => {
      console.log(e)
      this.closeLoading()
    })
  },
};
</script>

<style lang="scss" scoped>
</style>
